// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"30e5a550","430":"e8ff27e7","453":"d1eafb25","789":"ff972dc8","797":"90e90594"}[chunkId] + ".chunk.js";
};